import axios from 'axios';

// Owner-side "who is this case shared with?" — merges subcontractor grants + network
// referrals. Revoke/cancel reuse the existing per-mechanism endpoints.
const BASE = `${process.env.REACT_APP_SERVER}sharing`;
const SUB = `${process.env.REACT_APP_SERVER}subcontractors`;
const NET = `${process.env.REACT_APP_SERVER}network`;
const cfg = (token) => ({ headers: { Authorization: `Bearer ${token}` } });

// One call for the whole leads list: { [threadId]: { subs, referrals, total } }.
export async function getSharingSummary(token) {
  const { data } = await axios.get(`${BASE}/summary`, cfg(token));
  return data.summary || {};
}

// Full normalized share list for one case (owner-only).
export async function getCaseSharing(token, threadId) {
  const { data } = await axios.get(`${BASE}/case/${encodeURIComponent(threadId)}`, cfg(token));
  return data; // { threadId, counts, shares: [...] }
}

// Cut a subcontractor's live access (notifies them). Reuses the subcontractor endpoint.
export async function revokeSubcontractorGrant(token, grantId) {
  const { data } = await axios.post(`${SUB}/share/${grantId}/revoke`, {}, cfg(token));
  return data;
}

// Cancel a still-pending referral. Reuses the network endpoint.
export async function cancelReferral(token, referralId) {
  const { data } = await axios.post(`${NET}/referrals/${referralId}/cancel`, {}, cfg(token));
  return data;
}
